<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps<{ userId?: number | null; days: number }>();
const average = ref<number | null | undefined>(undefined);
const averageFormatted = computed(() => {
    if (!average.value) { return '-'; }
    const result: string[] = [];
    const days = Math.floor(average.value / 86400);
    if (days > 0) { result.push(`${days}d`); }
    const hours = Math.floor((average.value % 86400) / 3600);
    if (result.length || hours > 0) { result.push(`${hours}t`); }
    const minutes = Math.floor((average.value % 3600) / 60);
    if (result.length || minutes > 0) { result.push(`${minutes}m`); }
    return result.join(', ');
});
async function loadData(): Promise<void> {
    const response = await axios.get('/stats/time_to_sign_average', { params: { user_id: props.userId ?? null, days: props.days } });
    average.value = response.data.average;
}
onMounted(loadData);
watch(() => [props.userId, props.days], loadData);
</script>
<template><div><p v-if="average !== undefined">{{ averageFormatted }}</p><div v-else class="spinner-border" role="status"><span class="sr-only">Laddar</span></div></div></template>
<style scoped>p { font-size: 1.5em; }</style>
